/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import ReportExportForm from 'shared/ui/components/reporting/ReportExportForm.vue';

// Constants
const MANDATORY_FIELDS = ['lname', 'fname', 'email'];
const REPORT_JOB_KEY = 'report_job_key_${name}';

// Mixins
import exportModal from 'shared/ui/mixins/common/export-modal.js';

/**
 * @vue-prop {string} eventId the workspace ID
 * @vue-prop {string} reportName the name of the report to export
 * @vue-prop {string} title the title of the report
 * @vue-prop {string} icon the icon to use for the report
 * @vue-prop {alt-1|alt-2|alt-3|alt-4} iconStyle the style of the icon (colors)
 * @vue-prop {string} description the description for the report
 * @vue-prop {boolean} showPlatforms whether to show the platforms or not
 * @vue-prop {{name: string, label: string, value: boolean }[]} fields the list of the fields available for the report
 *
 * @example
 *
 * ```
 * import ReportExportModal from 'shared/ui/components/modals/ReportExportModal.vue';
 * // ....
 * this.$modal.show(ReportExportModal, {
 *     title: 'Fooo',
 *     description: 'Bar',
 *     eventId: this.eventId,
 *     reportName: 'foo'
 * }, {
 *     classes: 'small',
 *     height: 'auto'
 * });
 * ```
 *
 * @category shared.ui.components.modals
 * @exports ReportExportModal
 * @component
 */
const __vue_script__ = {
    name: 'ReportExportModal',

    components: { ReportExportForm },

    mixins: [exportModal],

    props: {
        event: {
            type: Object,
            required: true
        },

        reportName: {
            type: String,
            required: true
        },

        title: {
            type: String,
            required: true
        },

        icon: {
            type: String,
            default: 'list'
        },

        iconStyle: {
            type: String,
            default: 'alt-1'
        },

        shortDescription: {
            type: String,
            required: true
        },

        longDescription: {
            type: String,
            required: true
        },

        showPlatforms: {
            type: Boolean,
            default: true
        },

        showPaxFields: {
            type: Boolean,
            default: true
        },

        initialStartDate: {
            type: Date,
            default: null
        },

        initialEndDate: {
            type: Date,
            default: null
        },

        liveStreamId: {
            type: String,
            default: null
        },

        hideDates: {
            type: Boolean,
            default: false,
        },

        includeFpExtId: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            defaultFileName: 'report',
            fields: [],
            ready: false,
            submitSpy: 0
        };
    },

    computed: {
        reportKey() {
            return REPORT_JOB_KEY.replace('${name}', this.reportName);
        }
    },

    async created() {
        try {
            const fpTypes = this.includeConditionalFpTypes(['person']);

            const jobIdStored = localStorage.getItem(this.reportKey);
            if (jobIdStored) {
                // get the job id from storage and check status
                await this.getReport(jobIdStored);
            }

            const metadataFields = await this.$services.metadata.getMetadataForTypes(this.event._id, fpTypes, false, true, ['fp_status', 'fp_rsvp_status']);

            const fields = this.$utils.collections
                .sortByOrder(metadataFields, '__key', true)
                .map(field => {
                    return {
                        name: field.__key,
                        label: field.label || field.__key,
                        value: MANDATORY_FIELDS.includes(field.__key),
                        disabled: MANDATORY_FIELDS.includes(field.__key),
                        hidden: MANDATORY_FIELDS.includes(field.__key)
                    };
                });

            if (this.includeFpExtId) {
                fields.unshift({
                    name: 'fp_ext_id',
                    label: 'fp_ext_id',
                    value: true,
                    disabled: true,
                    hidden: true
                });
            }

            this.fields = fields;
        } catch (error) {
            console.error('[ReportExportModal] Could not load fields list', error.message);
        } finally {
            this.ready = true;
        }
    },

    methods: {

        /**
         * Tracks the export job for the current report
         *
         * @param {object} task the remote task to track for the progress
         */
        async onFormCompleted(task) {
            const jobId = task.reportId;
            localStorage.setItem(this.reportKey, jobId);
            await this.getReport(jobId);
        },

        async getReport(jobId) {
            try {
                const jobUrl = this.$services.analytics.getReportProgressUrl(this.event._id, jobId);

                await this.trackJob(jobId, jobUrl, jobUrl);

                this.downloadPath = this.$services.analytics.getReportResultUrl(this.event._id, jobId, this.liveStreamId);

            } catch (error) {
                this.handleError(error);
            } finally {
                this.polling = false;
                localStorage.removeItem(this.reportKey);
            }
        },

        includeConditionalFpTypes(arr) {
            if (this.reportName === 'leads') {
                arr.push('prospect');
            }

            return arr;
        }
    }

};


/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "report-export-modal modal-wrapper",
      class: { polling: _vm.polling },
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("span", {
          staticClass: "close",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
        _c("h3", [
          _c("div", { staticClass: "icon-wrapper", class: _vm.iconStyle }, [
            _c("i", { class: "ic-" + _vm.icon }),
          ]),
          _vm._v(_vm._s(_vm.title)),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "modal-body" },
        [
          _vm.showDownloadButton
            ? [
                _c("div", { staticClass: "download-link-wrapper" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("general.could_not_download"))),
                  ]),
                  _c(
                    "a",
                    {
                      ref: "downloadLink",
                      staticClass: "btn btn-primary",
                      attrs: { href: _vm.downloadPath, target: "_blank" },
                    },
                    [_vm._v(_vm._s(_vm.$t("analytics.exports.download")))]
                  ),
                ]),
              ]
            : [
                _c("p", [
                  _c("span", [_vm._v(_vm._s(_vm.shortDescription))]),
                  _c("i", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.longDescription,
                        expression: "longDescription",
                      },
                    ],
                    staticClass: "ic-info-fill",
                  }),
                ]),
                !_vm.error
                  ? [
                      _vm.polling
                        ? _c("div", [
                            _c("div", { staticClass: "alert alert-warning" }, [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "analytics.exports.already_downloading"
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.ready && !_vm.polling
                        ? _c("report-export-form", {
                            attrs: {
                              event: _vm.event,
                              "report-name": _vm.reportName,
                              fields: _vm.showPaxFields ? _vm.fields : [],
                              "show-platforms": _vm.showPlatforms,
                              "hide-dates": _vm.hideDates,
                              "submit-spy": _vm.submitSpy,
                              "initial-start-date": _vm.initialStartDate,
                              "initial-end-date": _vm.initialEndDate,
                              "live-stream-id": _vm.liveStreamId,
                            },
                            on: {
                              error: _vm.handleError,
                              completed: _vm.onFormCompleted,
                              submitting: function (value) {
                                return (_vm.disableSubmit = value)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm.polling
                        ? _c("progress-bar", {
                            attrs: { progress: _vm.progress },
                          })
                        : _vm._e(),
                    ]
                  : [
                      _c("div", { staticClass: "alert alert-error" }, [
                        _vm.error
                          ? _c("p", [_vm._v(_vm._s(_vm.error))])
                          : _vm._e(),
                        _c("p", [_vm._v(_vm._s(_vm.$t("general.try_later")))]),
                      ]),
                    ],
              ],
        ],
        2
      ),
      !_vm.showDownloadButton
        ? _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("general.cancel")))]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button", disabled: _vm.disableSubmit },
                on: {
                  click: function ($event) {
                    _vm.submitSpy = Date.now()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("analytics.exports.download")))]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/modals/ReportExportModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__